// TODO: Check if this is still used
export class ClientError extends Error {
  public status: number;
  public statusText: string;
  public data?: unknown;

  constructor(message: string, status: number, data?: unknown) {
    super(message);
    this.status = status;
    this.statusText = message;
    this.data = data;
    Object.setPrototypeOf(this, ClientError.prototype);
    Error.captureStackTrace(this, this.constructor);
  }
}
